"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventHandlerProvider = exports.EventHandlerContext = exports.DEFAULT_EVENT_HANDLER_CONTEXT = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Event Custom Config
// {
//   actions: [],
//   component_name: 'trade',
//   custom_data: {
//     side: 'buy'
//   }
// }

const DEFAULT_EVENT_HANDLER_CONTEXT = {};
exports.DEFAULT_EVENT_HANDLER_CONTEXT = DEFAULT_EVENT_HANDLER_CONTEXT;
const EventHandlerContext = /*#__PURE__*/(0, _react.createContext)(DEFAULT_EVENT_HANDLER_CONTEXT);
exports.EventHandlerContext = EventHandlerContext;
const EventHandlerProvider = ({
  config,
  children
}) => {
  const configuration = (0, _react.useMemo)(() => config !== null && config !== void 0 ? config : DEFAULT_EVENT_HANDLER_CONTEXT, [config]);
  return /*#__PURE__*/_react.default.createElement(EventHandlerContext.Provider, {
    value: configuration
  }, children);
};
exports.EventHandlerProvider = EventHandlerProvider;